(function () {
    'use strict';

    angular.module('sempraWebapp').controller('periodicSummaryController', periodicSummaryController);

    /** @ngInject */
    function periodicSummaryController ($scope, PeriodicSummaryViewModel, periodicSummaryActions, dialogsService, $q, $translate, $mdToast, $log) {
        var vm = this;
        vm.fromDateMax;

        vm.summary = new PeriodicSummaryViewModel();

        vm.print = function () {
            /* eslint-disable */
            window.print();
            /* eslint-enable */
        };

        vm.toDateSelected = function(){
            vm.fromDateMax =  vm.summary.invoiceTo;
        };

        vm.sortChanged = function(order){
            vm.summary.invoiceOrderingChange(order);
            refreshInvoices();
        };

        vm.changeType = function (invoiceType) {
            vm.summary.searchRadioButton.type = invoiceType;
            vm.summary.invoicePage = 1;
            refreshInvoices();
        };

        vm.changeYear = function () {
            refreshInvoices();
        };

        vm.pageChanged = function(page, limit){
            vm.summary.invoicePaginationChange(page, limit);
            refreshInvoices();
        };

        vm.search = function(){
            refreshInvoices();
        };

        vm.sendInvoice = function(invoiceId, invoiceNumber){

            dialogsService.showConfirmDialog($translate.instant('INVOICE_NUMBER_HEADER') + ' - "' + invoiceNumber +'"'  , $translate.instant('INVOICING_NOTIFICATION_TEXT'), $translate.instant('YES')).then(function(){
                periodicSummaryActions.updateInvoice(invoiceId, invoiceNumber, 'approval').then(function(){
                    refreshPeriodicSummary();
                    refreshInvoices();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant('SENT_INVOICE_NOTIFICATION'))
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                });
            });
        };

        vm.downloadInvoice = function(id){
            periodicSummaryActions.downloadInvoice(id).then(function(data){
                var invoiceTitle = data.headers().pdfname;
                getPdfFile(data.data, invoiceTitle);
            });
        };

        vm.openOptions = function($mdMenu, ev, data) {
            if(data.company.regionId === 2) {
               vm.summary.downloadOptions = vm.summary.forSerbiaRegion;
            } else {
                vm.summary.downloadOptions = vm.summary.allRegions;
            }
            $mdMenu.open(ev);
        }

        vm.downloadInvoices = function(id, type){

            switch (type) {
                case 'invoice':
                    periodicSummaryActions.downloadInvoice(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
                case 'b2b':
                    periodicSummaryActions.downloadB2bSpec(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
                case 'b2c':
                    periodicSummaryActions.downloadB2cSpec(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
            }

        };

        vm.toggleAccordian = function(invoiceType){
            vm.summary.financialData[invoiceType].collapsed = (vm.summary.financialData[invoiceType].collapsed) ? false : true;
        };

        init();

        function refreshPeriodicSummary(){
            periodicSummaryActions.getPeriodicSummary().then(function (data) {
                vm.currency = data.currencyCode;
                vm.summary.refresh(data);
            }, function () {
                //TODO error handling
            });
        }

        function refreshInvoices(){
            vm.promise = periodicSummaryActions.getInvoices(
                vm.summary.selectedYear,
                vm.summary.searchRadioButton.type,
                vm.summary.invoicePage - 1,
                vm.summary.invoicePageSize,
                vm.summary.invoiceOrderBy,
                vm.summary.invoiceOrder).then(function(data){
                    vm.summary.refreshInvoiceData(data);
                }, function (errorData) {
                    $log.log('an error occured' + errorData);
            });
        }

        function createYearList () {
            for (var i = vm.summary.minYear; i < vm.summary.maxYear; i++) {
                vm.summary.invoiceFromYear.push(i);
            }
            vm.summary.yearList = vm.summary.invoiceFromYear.reverse();
        }

        function getPdfFile(data, invoiceTitle){

            var file = new Blob([data], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);

            var file_path = fileURL;
            /* eslint-disable */
            var a = document.createElement('A');
            a.href = file_path;
            a.download = invoiceTitle;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            /* eslint-enable */

        }


        function init () {
            $scope.$on('$destroy', destroy);
            refreshPeriodicSummary();
            refreshInvoices();
            createYearList();
        }

        function destroy () {
            if (vm.summary !== null) {
                vm.summary.destroy();
            }
        }
    }
})();
